import {html} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import B2bElement from '../../b2b-element.js';
import './auth/login/b2b-public-login.js';
import './auth/logout/b2b-public-logout.js';
import './auth/email/b2b-public-email.js';
import './auth/registration/b2b-public-registration.js';
import './auth/email/b2b-public-linkemail.js';
import './auth/mfa/b2b-public-mfa.js';
import './auth/mfa/b2b-public-mfalink.js';
import './auth/password/b2b-public-forgot-password.js';
import './auth/password/b2b-public-reset-password.js';

@customElement('b2b-public-auth')
export class B2bPublicAuth extends B2bElement {
  @property({type: Object, attribute: false})
  accessor route;

  render() {
    return html`
      <mta-page-lit
          .route="${this.route}"
          class="app"
          pattern="/:page/:args"
          @mta-page-title-changed="${this.__titleChanged}"
          .pages="${{
            login: () => html`
              <b2b-public-login></b2b-public-login>
            `,
            logout: () => html`
                <b2b-public-logout></b2b-public-logout>
            `,
            email: () => html`
              <b2b-public-email></b2b-public-email>
            `,
            registration: () => html`
              <b2b-public-registration></b2b-public-registration>
            `,
            linkemail: routeData => html`
              <b2b-public-linkemail .route="${routeData.data}"></b2b-public-linkemail>
            `,
            mfa: () => html`
              <b2b-public-mfa></b2b-public-mfa>
            `,
            mfalink: routeData => html`
              <b2b-public-mfalink .route="${routeData.data}"></b2b-public-mfalink>
            `,
            forgotPassword: () => html`
              <b2b-public-forgot-password></b2b-public-forgot-password>
            `,
            resetPassword: routeData => html`
              <b2b-public-reset-password .route="${routeData.data}"></b2b-public-reset-password>
            `
          }}">
      </mta-page-lit>
    `;
  }
}
